<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8.27996C14.0023 9.15987 13.7967 10.0279 13.4 10.8133C12.9296 11.7544 12.2065 12.5461 11.3116 13.0995C10.4168 13.6529 9.38548 13.9462 8.33332 13.9466C7.45341 13.9489 6.5854 13.7433 5.79999 13.3466L2 14.6133L3.26666 10.8133C2.86995 10.0279 2.66437 9.15987 2.66667 8.27996C2.66707 7.2278 2.96041 6.19653 3.51381 5.30166C4.06721 4.4068 4.85883 3.68368 5.79999 3.2133C6.5854 2.81659 7.45341 2.61101 8.33332 2.6133H8.66666C10.0562 2.68996 11.3687 3.27647 12.3527 4.26054C13.3368 5.2446 13.9233 6.55706 14 7.94663V8.27996Z" stroke="#A1A8B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.2482 5C15.2482 6.79508 13.7934 8.25 11.9991 8.25C10.2048 8.25 8.75 6.79508 8.75 5C8.75 3.20492 10.2048 1.75 11.9991 1.75C13.7934 1.75 15.2482 3.20492 15.2482 5Z" fill="#A1A8B8" stroke="#FBFDFE" stroke-width="1.5"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>